import { useMemo } from "react"
import { get, includes, size } from "lodash"
import { NUMERIC_OPERATORS } from "helpers/filters/filter-ons/numbers"
import type { BetaFilterOn, BetaFilterOnOption } from "helpers/filters/filter-ons"
import { SecuritySearchFilter } from "resources/filters"
import { DataStatus, OK } from "helpers/data-statuses"

interface UseBetaFiltersParams {
  filter: SecuritySearchFilter | null
  missingDataFiles: string[]
}

export function useBetaFilters({ filter, missingDataFiles }: UseBetaFiltersParams): [BetaFilterOn[], DataStatus] {
  const filters = useMemo(() => {
    const betasAreMissing = size(["predictedBeta", "historicalBeta"].filter(betaType => !includes(missingDataFiles, betaType))) === 0

    if (betasAreMissing) return []

    const options: BetaFilterOnOption[] = []
    if (!includes(missingDataFiles, "historicalBeta")) {
      options.push({
        label: "Historical",
        type: "beta",
        dataType: "numeric",
        operators: NUMERIC_OPERATORS,
        value: "historical",
        isDisabled: !!get(filter, "beta.historical"),
      })
    }
    if (!includes(missingDataFiles, "predictedBeta")) {
      options.push({
        label: "Predicted",
        type: "beta",
        dataType: "numeric",
        operators: NUMERIC_OPERATORS,
        value: "predicted",
        isDisabled: !!get(filter, "beta.predicted"),
      })
    }
    const betaFilter: BetaFilterOn = {
      label: "Beta",
      type: "beta",
      options,
    }
    return [betaFilter]
  }, [missingDataFiles, filter])

  return [filters, OK]
}
